import { canUseDOM } from 'exenv';

export default function loadLiftIgniterTracker() {
  if (canUseDOM) {
    if (window.$p) {
      window.$p('send', 'pageview');
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/utils/third_party_trackers/liftIgniter.js